export default "__VITE_ASSET__CqrQc1mL__"